import { Country, Organization, PostalAddress, WithContext } from "schema-dts";

import { isProduction } from "~/env";

export const EQUIPMENTSHARE_BASE_URL = `https://${
  isProduction ? "" : "staging-"
}www.equipmentshare.com`;

export const EQUIPMENTSHARE_LOGO_URL =
  "https://static.estrack.com/logo/1500/0/equipmentshare_logos_2023_hex_gear_light.png";

export const EQUIPMENTSHARE_ICON_URL =
  "https://uploads-ssl.webflow.com/60cb2013a506c737cfeddf74/60d0867d1398775f9a3669b2_logo-256x256.png";

export const EQUIPMENTSHARE_IMAGE_URL =
  "https://cdn.prod.website-files.com/60cb2013a506c737cfeddf74/620bbc52f1de86cc1ff1e219_Company%20Page-100.jpg";

export const BASE_ORGANIZATION_SCHEMA: WithContext<
  Exclude<Organization, string>
> = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "EquipmentShare",
  url: EQUIPMENTSHARE_BASE_URL,
  logo: EQUIPMENTSHARE_LOGO_URL,
};

export const COUNTRY_SERVED: WithContext<Country> = {
  "@context": "https://schema.org",
  "@type": "Country",
  name: "US",
};

export const POSTAL_ADDRESS_SCHEMA: WithContext<PostalAddress> = {
  "@context": "https://schema.org",
  "@type": "PostalAddress",
  streetAddress: "5710 Bull Run Dr",
  addressLocality: "Columbia",
  addressRegion: "Missouri",
  postalCode: "65201",
  addressCountry: "US",
};
